import type { TemplateCategoryApiGateway } from "@/modules/template/gateway/templateCategoryApiGateway"
import type { EditTemplateCategoryInputDto, TemplateCategoryDto } from "@/modules/template/gateway/templateCategoryDto"
import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import type { Paginated } from "@/modules/utils/paginated"
import { TemplateCategoryDtoSchema } from "@/modules/template/gateway/templateCategoryDto"

export class TemplateCategoryApi implements TemplateCategoryApiGateway {
  private templateCategoryApiUrl = `/template-category`

  constructor(private api: ApiClient) {}

  async getTemplateCategories(
    page: number,
    pageSize: number,
    searchTerm?: string,
  ): Promise<Paginated<TemplateCategoryDto>> {
    const resultDto = await this.api.get<Paginated<TemplateCategoryDto>>(`${this.templateCategoryApiUrl}`, {
      params: { page, size: pageSize, search: searchTerm },
    })
    return {
      ...resultDto.data,
      content: resultDto.data.content.map((item) => LoggerService.parseApiDto(TemplateCategoryDtoSchema, item)),
    }
  }

  async createTemplateCategory(templateCategoryInput: EditTemplateCategoryInputDto): Promise<TemplateCategoryDto> {
    const resultDto = await this.api.post<TemplateCategoryDto>(`${this.templateCategoryApiUrl}`, templateCategoryInput)
    return LoggerService.parseApiDto(TemplateCategoryDtoSchema, resultDto.data)
  }

  async updateTemplateCategory(
    id: string,
    templateCategoryInput: EditTemplateCategoryInputDto,
  ): Promise<TemplateCategoryDto> {
    const resultDto = await this.api.put<TemplateCategoryDto>(
      `${this.templateCategoryApiUrl}/${id}`,
      templateCategoryInput,
    )
    return LoggerService.parseApiDto(TemplateCategoryDtoSchema, resultDto.data)
  }

  async deleteTemplateCategory(id: string): Promise<void> {
    await this.api.delete(`${this.templateCategoryApiUrl}/${id}`)
  }
}
